export default __webpack_public_path__ + "static/media/avatar-526x526.5ec8c12d.png";